import { apiInterceptor } from 'utils/apiInterceptor';
export async function GetChannels(
    projectId,
    page = 1,
    search = '',
    status = null
) {
    let url = `${process.env.REACT_APP_MYXP_API_V2}/manager/livestream/channels?projectId=${projectId}&page=${page}&limit=10&search=${search}`;
    if (status) {
        url += `&status=${status}`;
    }

    const response = await apiInterceptor(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return await response.json();
}

export async function GetAllChannels(projectId) {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/channels/allChannels?projectId=${projectId}`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );
    return await response.json();
}
